import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FragileIcon } from 'src/features/delivery/components/icons';
import ModeIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import EditOffIcon from '@mui/icons-material/EditOffOutlined';

const useStyles = makeStyles(() => ({
  inlineInformation: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 0 3px 0',
  },
}));

export type ParcelInformationParams = {
  value: {
    requiresAttention: boolean;
    containsAlcohol?: boolean;
  };
};

export const ParcelInformation = ({ value }: ParcelInformationParams) => {
  const classes = useStyles();
  return (
    <>
      {value.containsAlcohol ? (
        <Box className={classes.inlineInformation}>
          <ModeIcon />&nbsp;&nbsp;Signature Required
        </Box>
      ) : (
        <Box className={classes.inlineInformation}>
          <EditOffIcon />&nbsp;&nbsp;Authority to Leave
        </Box>
      )}
      {value.requiresAttention && (
        <Box className={classes.inlineInformation}>
          <FragileIcon />&nbsp;&nbsp;Package Requires Attention
        </Box>
      )}
    </>
  );
};
